import { COVER_TYPES } from '@/constants/insurance';
import lang from '@/lang/middleware/products/protection/life-insurance';

export default async ({ route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const coverType = COVER_TYPES.find(type => type.path === route.path.split('/')[1]);
  coverType.name = store.$i18n.t(`coverTypes.${coverType.code}.name`);
  await store.commit('products/setCoverType', coverType);
};
